import React from "react";

function DebugInfos({ data }: { data: any }) {
  return (
    <div className="text-center w-full py-12">
      {/* <div className="text-center mb-8 p-4 bg-blue-100 dark:bg-blue-900/20 rounded-lg">
          Debug: Found {data?.length || 0} projects
        </p>
      </div> */}

      <div className="bg-red-100 dark:bg-red-900/20 p-6 rounded-lg">
        <h3 className="text-xl font-semibold text-red-700 dark:text-red-300 mb-2">
          Debug Information
        </h3>
        {/* <p className="text-red-600 dark:text-red-400"> */}
        <p className="text-sm text-blue-700 dark:text-blue-300">
          data is not available. Type: {typeof data},
          {(Array.isArray(data) && `Length: ${data?.length}`) || "undefined"}
        </p>
        <pre className="mt-4 text-xs text-red-500 bg-red-50 dark:bg-red-900/10 p-2 rounded overflow-auto">
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  );
}

export default DebugInfos;
